import * as React from 'react';
import '../css/SuperUserPageView.css';
import {IProduct, IProductLogo} from "../../../infrastructure/interfaces";
import { Route } from 'react-router-dom';

import agronomyReferenceImage from '../img/agronomySheets.png';
import productLogosImage from '../img/productLogos.png';
import coversImage from '../img/coverImages.png';
import seedIconsImage from '../img/seedIcons.png'
import fillerImagesImage from '../img/fillerImagesImage.png'
import coverSmallImages from '../img/coverSmallImages.png';
import brandingsImage from '../img/brandings.png';
import logosImage from '../img/complimentaryProductLogos.png';
import postcardImage from '../img/postcardOne.png';
import posterImage from '../img/poster.png';
import seedDividerImage from '../img/seedDividers.png';
import techSheetImage from '../img/techSheets.png';
import fullPageCatalogImage from '../img/fullPageCatalogImages.png';
import shelDividerImage from '../img/shelf_divider.png';


export interface IManageImagesProps {
  productLogosList: [IProductLogo];
}

export interface IManageImagesState {
    editingProduct: IProduct | null;
}

export default class ManageImagesTable extends React.Component<IManageImagesProps, IManageImagesState> {
  tableRow: HTMLElement;
  constructor(props: IManageImagesProps) {
    super(props);
    this.state = {
      editingProduct: null,
    };
  }

  render() {

    return (
      <div className="inner-su-container">
        <div className="manage-single-item-row">
          <div className="in-row-text-container">
            Manage Images
          </div>
        </div>


        <table className="table-scrollableSU images-table">
          <tbody className="table-scrollable-body">
              <tr>
              <td className="imageMainTableCell">
                <Route
                    render={({ history }) => {
                      return (
                          <button onClick={() => history.push('/ManageCovers')} title="Covers">
                              <div><b>Manage Cover Images</b></div>
                              <img className="imageMainTableImage" src={coversImage} />
                          </button>
                      );
                    }}
                  />
                </td>
                <td className="imageMainTableCell">
                  <Route
                      render={({ history }) => {
                          return (
                              <button onClick={() => history.push('/ManageFillerImages')} title="Filler Images">
                                  <div><b>Manage Filler Images</b></div>
                                  <img className="imageMainTableImage" src={fillerImagesImage} />
                              </button>
                          );
                      }}
                  />
              </td>
              </tr>
              <tr>
                <td className="imageMainTableCell">
                <Route
                    render={({ history }) => {
                      return (
                          <button onClick={() => history.push('/ManageProductLogos')} title="Product Logos">
                              <div><b>Manage Product Logos</b></div>
                              <img className="imageMainTableImage" src={productLogosImage} />
                          </button>
                      );
                    }}
                  />
                </td>
                <td className="imageMainTableCell">
                <Route
                    render={({ history }) => {
                      return (
                          <button onClick={() => history.push('/ManageComplimentaryLogos')} title="Complimentary Logos">
                              <div><b>Manage Complimentary Logos</b></div>
                              <img className="imageMainTableImage" src={logosImage} />
                          </button>
                      );
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td className="imageMainTableCell">
                <Route
                    render={({ history }) => {
                      return (
                          <button onClick={() => history.push('/ManageSeedIcons')} title="Trait Logos">
                              <div><b>Manage Trait Logos</b></div>
                              <img className="imageMainTableImage" src={seedIconsImage} />
                          </button>
                      );
                    }}
                  />
                </td>
                <td className="imageMainTableCell">
                  <Route
                      render={({ history }) => {
                        return (
                            <button onClick={() => history.push('/ManageCropCoverImages')} title="Cover Images">
                                <div><b>Manage Cover Icons</b></div>
                                <img className="imageMainTableImage" src={coverSmallImages} />
                            </button>
                        );
                      }}
                  />
                </td>
              </tr>
              <tr>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManageSeedDividers')} title="Seed Dividers">
                                      <div><b>Manage Seed Dividers</b></div>
                                      <img className="imageMainTableImage" src={seedDividerImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManageShelfDividers')} title="Shelf Dividers">
                                      <div><b>Manage Shelf Dividers</b></div>
                                      <img className="imageMainTableImage" src={shelDividerImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
              </tr>
              <tr>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManagePosterImages')} title="Poster Images">
                                      <div><b>Manage Poster Images</b></div>
                                      <img className="imageMainTableImage" src={posterImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManagePostcardImages')} title="Postcard Images">
                                      <div><b>Manage Postcard Images</b></div>
                                      <img className="imageMainTableImage" src={postcardImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
              </tr>
              <tr>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManageTechSheets')} title="Tech Sheets">
                                      <div><b>Manage Tech Sheets</b></div>
                                      <img className="imageMainTableImage" src={techSheetImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManageAgronomyReferenceSheets')} title="Agronomy Reference Sheets">
                                      <div><b>Manage Sustainability/Agronomy Sheets</b></div>
                                      <img className="imageMainTableImage" src={agronomyReferenceImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
              </tr>
              <tr>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManageBrandings')} title="Brandings">
                                      <div><b>Manage Brandings</b></div>
                                      <img className="imageMainTableImage" src={brandingsImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
                  <td className="imageMainTableCell">
                      <Route
                          render={({ history }) => {
                              return (
                                  <button onClick={() => history.push('/ManageFullPageCatalogImages')} title="Full Page Catalog Images">
                                      <div><b>Manage Full Page Catalog Images</b></div>
                                      <img className="imageMainTableImage" src={fullPageCatalogImage} />
                                  </button>
                              );
                          }}
                      />
                  </td>
              </tr>
          </tbody>
        </table>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageImages.tsx